import { LoginComponent } from './../../../../../lib/ng2-sapmp/src/pages/login/login.component';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { throwError, Observable } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { PERMISSION } from 'config';
import { CareModel, SelectedFan } from '../models/care.models';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { FanListModel } from 'lib/ng2-sapmp/src/models/user';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()

export class CareComponentService {
  careefotadetails: any;
  private headers;
  minutesLeft: any;
  timeStamp: any;
  isCopied: boolean = false;

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }
  

  doRequestCareService(url) {
    return this.httpClientService.get(url)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  getFanNoDetails(url) {
    return this.httpClientService.authorizedGet(url)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  setSelectedFan(fanId) {
    sessionStorage.setItem('selectedFAN', fanId);
  }
  getSelectedFan() {
    return sessionStorage.getItem('selectedFAN');
  }

  setSelectedRequest(reqId) {
    sessionStorage.setItem('selectedREQ', reqId);
  }
  getSelectedRequest() {
    return sessionStorage.getItem('selectedREQ');
  }

  setSelectedCompanyName(fanId) {
    sessionStorage.setItem('selectedCompanyName', fanId);
  }
  getSelectedCompanyName() {
    return sessionStorage.getItem('selectedCompanyName');
  }

  getReportList(fanNo) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('fanNo', fanNo);
    return this.httpClientService.authorizedGet(this.utilityService.getEnvConfig().efotaRetrieveReport, headers)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  efotaUpdateReport(reportId, publish, remove) {
    let headers = new HttpHeaders();
    let requestBody = "";
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('reportId', reportId);
    headers = headers.append('publish', publish);
    headers = headers.append('delete', remove);
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().efotaUpdateReport, requestBody, headers)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  getAllFanDetails() {
    let headers = new HttpHeaders();
    headers = headers.append('filter', 'filter: {_id:1,body.enrollmentstatus:1,body.tcmemailaddress:1}');
    headers.append('Content-Type', 'text/json');
    return this.httpClientService.authorizedGet(this.utilityService.getEnvConfig().getAllFanDetails, headers)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  getAllRequestDetails(qryString) {
    let url = this.utilityService.getEnvConfig().efotaAdminChangeRequests;
    let queryString = { "queryString": qryString };
    // let queryString = '';
    return this.httpClientService.authorizedPost(url, queryString).pipe(
      map((res: HttpResponse<any>) => {
        //return res;
        return res.body;
      }), catchError(this.handleError));
  }

  handleError = (error) => {
    return throwError(error);
  }
  setCareModel(careContext: CareModel) {
    sessionStorage.setItem('savedCareRequest', JSON.stringify(careContext));
  }

  getCareModel() {
    return JSON.parse(sessionStorage.getItem('savedCareRequest')) || new CareModel();
  }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('jwtToken'));
    return headers;
  }

  getCareContextDetails() {
    const headers = this.get_headers();
    return this.httpClientService.get(this.utilityService.getEnvConfig().getCarePageConfigUrl, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          if (res.headers.get('SERVICE-AUTH-TOKEN') != null) {
            sessionStorage.setItem('jwtToken', res.headers.get('SERVICE-AUTH-TOKEN'));
          }
          return res.body;
        }
        )
        , catchError(this.handleError));
  }


  logoutCurrentUser() {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('cart');
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('sapmp_jwtToken');
    sessionStorage.removeItem('permissions');
    sessionStorage.removeItem('steps');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('currentRoute');
    sessionStorage.removeItem('previousRoute');
    sessionStorage.removeItem('landingPageRoute');
    sessionStorage.removeItem('loginSuccessUrl');
    sessionStorage.removeItem('CARE_LOGON');
    return;
  }

  getFANList(companyid) {
    // here we concat companyid with /device/deployement/fan/{companyid}
    const fanUrl = this.utilityService.getEnvConfig().getFANListMock[1];
    return this.httpClientService.get(fanUrl)
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));
  }

  updateRequestStatus(currentRequest, customerfanstatus, adminComments) {
    let data = {
      "_id": currentRequest._id,
      "change": currentRequest.change,
      "name": currentRequest.name,
      "type": currentRequest.type,
      "meta": {
        "fanNo": currentRequest.meta.fanNo,
        "groupName": currentRequest.meta.groupName,
        "changeType": currentRequest.meta.changeType,
        "request": currentRequest.meta.request,
        "requesterName": currentRequest.meta.requesterName,
        "requesterPhone": currentRequest.meta.requesterPhone,
        "requesterEmail": currentRequest.meta.requesterEmail,
        "requesterCompanyName": currentRequest.meta.requesterCompanyName,
        "adminComments": adminComments,
        "envPortal": currentRequest.meta.envPortal
      },
      "status": customerfanstatus,
      "date": currentRequest.date
    }
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().efotaUpdateChangeRequest + currentRequest._id, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  
  updateReportRequestStatus(currentRequest, customerfanstatus, adminComments) {
    let data = {
      "_id": currentRequest._id,
      "change": currentRequest.change,
      "name": currentRequest.name,
      "type": currentRequest.type,
      "meta": {
        "fanNo": currentRequest.meta.fanNo,
        "groupName": currentRequest.meta.groupName,
        "reportType": currentRequest.meta.reportType,
        "request": "",
        "requesterName": currentRequest.meta.requesterName,
        "requesterPhone": currentRequest.meta.requesterPhone,
        "requesterEmail": currentRequest.meta.requesterEmail,
        "requesterCompanyName": currentRequest.meta.requesterCompanyName,
        "adminComments": adminComments,
        "envPortal": currentRequest.meta.envPortal
      },
      "status": customerfanstatus,
      "date": currentRequest.date
    }
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().efotaUpdateChangeRequest + currentRequest._id, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  postStatusEfota(pageJson, customerfanstatus, devicesCount, adminReasons, pseudoCTN) {
    let data = {
      "_id": pageJson.body.foundationAccountNumber,
      "body": {
        "companyName": pageJson.body.companyName,
        "contactName": pageJson.body.contactName,
        "phoneNumber": pageJson.body.phoneNumber,
        "emailAddress": pageJson.body.emailAddress,
        "bestTimeToContact": pageJson.body.bestTimeToContact,
        "city": pageJson.body.city,
        "state": pageJson.body.state,
        "zipCode": pageJson.body.zipCode,
        "foundationAccountNumber": pageJson.body.foundationAccountNumber,
        "environmentPortal": pageJson.body.environmentPortal,
        // "productCode": pageJson.productCode,
        "enrollmentStatus": customerfanstatus,
        "generatedTime": pageJson.body.generatedTime,
        "serviceRequested": pageJson.body.serviceRequested,
        "billingAccountNumber": pageJson.body.billingAccountNumber,
        "notificationPreference": pageJson.body.notificationPreference,
        "noOfDevices": devicesCount,
        "ctnDetails": pageJson.body.ctnDetails,
        "adminComments": adminReasons,
        "pseudoCtn": pseudoCTN
      }
    }
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().updateEnrollStatus + pageJson.body.foundationAccountNumber, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  saveReviewedFan(reviewedData: Array<SelectedFan>) {
    sessionStorage.setItem('ReviewedData', JSON.stringify({ reviewedData }));
    console.log(reviewedData);
    return this.httpClientService.post(this.utilityService.getEnvConfig().submitLaunchContextSelectedParticipation,
      reviewedData, this.get_headers())
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));

  }

  getReviewedFanData() {
    return sessionStorage.getItem('ReviewedData') ? JSON.parse(sessionStorage.getItem('ReviewedData')) : new Array<SelectedFan>();
  }



  indexOfObjectbyValue(data, field, search) {
    let i = 0;
    let ind = -1;
    for (let cols of data) {
      if (cols[field] === search) {
        ind = i;
      }
      i++;
    }
    return ind;
  }

  setCurrentRouteInfo(url) {
    const urlArr = url.split('/');
    this.authenticationService.setAuthToken('CARE_LOGON', urlArr[2]);
  }

  getCurrentRouteInfo() {
    return this.authenticationService.getAuthToken('CARE_LOGON');
  }

  UpdateEmail(url, data) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    headers = headers.append('customerEmail', data.customerEmail);
    headers = headers.append('customerAgent', data.agentUserId);
    return this.httpClientService.get(url, headers)
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));
  }

  verifyFan(url) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    headers = headers.append('customerEmail', 'appmarket');
    headers = headers.append('customerAgent', 'care');
    // let getUrl = url + fan;
    return this.httpClientService.get(url, headers)
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));
  }

  getMultiFans(url) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    headers = headers.append('portal', 'appmarket');
    headers = headers.append('channel', 'care');
    return this.httpClientService.get(url, headers)
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));
  }




  postFile(csvrecord, type="") {
    let headers = new HttpHeaders();
    if(type != "" && (type == "file_upload" || type == "de-enroll" || type == "de-enroll_new_order")){
        headers = headers.append("actionType", type);
    }
    headers = headers.append('Content-Type', 'text/json');
    //  let data = [];  
    //  data.push(csvrecord);  
    //   console.log(data);
    let url = this.utilityService.getEnvConfig().getuploadfiles;
    return this.httpClientService.authorizedPost(url, csvrecord, headers).pipe(
      map((res: HttpResponse<any>) => {
        //return res;
        return res.body;
      }), catchError(this.handleError));
  }

  postZTEFile(csvrecord) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    let url = this.utilityService.getEnvConfig().getzteuploadfiles;
    return this.httpClientService.authorizedPost(url, csvrecord, headers).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }
  
  postFileKME(csvrecord) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    let url = this.utilityService.getEnvConfig().getkmeuidetails;
    return this.httpClientService.authorizedPost(url, csvrecord, headers).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  convertDate(epochDate) {
    var date = new Date(epochDate);
    var year = date.getFullYear();
    var mm = date.getMonth() + 1;
    var dd = date.getDate();
    var month = mm.toString().length === 2 ? "" + mm : "0" + mm;
    var day = dd.toString().length === 2 ? "" + dd : "0" + dd;
    return year + "-" + month + "-" + day;
    //return "" + year + "-" + month + "-" + day;
  }

  convertOnlyTime(fullDate) {
    let sampleDate = new Date(fullDate);
    let newTime = sampleDate.toString().substring(15, 24) + " ET";
    return newTime;
  }

  getabmdata(querystring) {
    console.log(querystring);
    let url = this.utilityService.getEnvConfig().getcareabmdetails;
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
        map((res: HttpResponse<any>) => {
          // console.log("response");
          console.log(res);
          return res.body;
        }), catchError(this.handleError));
  }

  updateDeviceStatus(querystring) {
    let url = this.utilityService.getEnvConfig().deviceStatusUpdate;
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }), catchError(this.handleError));
  }

  updateAppleFeStatus(querystring) {
    let url = this.utilityService.getEnvConfig().appleFeStatusUpdate;
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }), catchError(this.handleError));
  }

  encryptImei(imei: string): Observable<unknown> {
    const url = this.utilityService.getEnvConfig().encryptImei + '?imei=' + encodeURIComponent(imei);
    return this.httpClientService.authorizedGet(url).pipe(
      map((res: HttpResponse<unknown>) => res.body),
      catchError(this.handleError));
  }

  getTrackingData(querystring) {
    console.log(querystring);
    let url = this.utilityService.getEnvConfig().getcareabmdetails;
    let headers = new HttpHeaders();
    headers = headers.append('Api-Type', 'New');
    return this.httpClientService
      .authorizedPost(url, querystring, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          console.log(res);
          return res.body;
        }), catchError(this.handleError));
}

getTransactionLogs(querystring, id) {
  console.log(querystring);
  let url = this.utilityService.getEnvConfig().getcareabmdetails;
  let headers = new HttpHeaders();
  headers = headers.append('Api-Type', 'New');
  headers = headers.append('imei', id);
  return this.httpClientService
    .authorizedPost(url, querystring, headers)
    .pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
}
  
  getDMPWhitelistFans(data) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().getcareDmpWhiteistFans, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  getSavedDmpwhitelist(dmpId: string ,payloadData ) {
    let headers = new HttpHeaders();
    let requestBody = payloadData;
    headers = headers.append('documentId', dmpId);
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().saveDmpwhitelist, requestBody, headers)
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  getDeviceEnrollmentData(querystring) {
    //console.log(querystring);
    let url = this.utilityService.getEnvConfig().getcareDeviceEnrollmentDetails;
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
        map((res: HttpResponse<any>) => {
          //console.log(res);
          return res.body;
        }), catchError(this.handleError));
  }


  convertEpochToDate(epochDate) {
    var date = new Date(epochDate);
    var year = date.getFullYear();
    var mm = date.getMonth() + 1;
    var dd = date.getDate();
    var month = mm.toString().length === 2 ? "" + mm : "0" + mm;
    var day = dd.toString().length === 2 ? "" + dd : "0" + dd;
    return month + "/" + day + "/" + year;
  }
  convertDateTimeToDate(fullDate) {
    let newDate = JSON.stringify(fullDate);
    let mm = newDate.slice(6, 8);
    let dd = newDate.slice(9, 11);
    let yyyy = newDate.slice(1, 5);
    return mm + "/" + dd + "/" + yyyy;
  }

  convertEpochtoET(epochDate) {
    let newDate = new Date(epochDate);
    let modifiedDate = newDate.toISOString().slice(0,10);
    let modifiedTime = newDate.toLocaleTimeString();
    let updatedTime = modifiedDate + " " + modifiedTime + " " + "ET";
    return updatedTime;
  }

  sendEmail(data) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().notificationClient, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  getAllEnrollments(data) {
    return this.httpClientService.authorizedPost(this.utilityService.getEnvConfig().efotaEnrollments, data).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }), catchError(this.handleError));
  }

  convertOnlyTimeToEt(fullDate : any){
    let sampleDate = new Date(fullDate);
    sampleDate = new Date(sampleDate.toLocaleString("en-US", {timeZone: "America/Havana"}));
    let newTime = sampleDate.toString().substring(15, 24) + " ET";
    return newTime;
  }

  updateProfile(url, fan, email) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    headers = headers.append('customerEmail', email);
    headers = headers.append('fan', fan);
    // headers = headers.append('iv-user', 'vb1450');
    // headers = headers.append('iv-groups', '"HRUserGroup","UserAdmin","ABCASA"'); //"G_ABS","G_ABS_PRMR"
    // let getUrl = url + fan;
    return this.httpClientService.get(url, headers)
      .pipe(
        map((test: HttpResponse<any>) => test.body)
        , catchError(this.handleError));
      }
      
  getBulkSchedulersRunTime(){
    const headers = this.get_headers();
    console.log(this.utilityService.getEnvConfig().getBulkSchedulerRunTimeUrl);
    return this.httpClientService.authorizedGet(this.utilityService.getEnvConfig().getBulkSchedulerRunTimeUrl)
    .pipe(
    map((res: HttpResponse<any>) => {
      this.timeStamp = JSON.stringify(res.body);
            var schedulerTime = this.timeStamp.substring(14,38);
            if(schedulerTime !== ""){
            var schedulerDate= new Date(schedulerTime);
             var schedulerMilliSec = schedulerDate.getTime();
             var schedulerNextRun = new Date (schedulerMilliSec+10 * 60 * 1000);
             var schedulerNextRunMS = schedulerNextRun.getTime();
        
            var systemCurrentDT = new Date();
        var systemCurrentDTMS = systemCurrentDT.getTime();
        const minutes = ( schedulerNextRunMS - systemCurrentDTMS ) / (1000 * 60) % 60;
        console.log(minutes);
        this.minutesLeft = Math.trunc(minutes);
      return this.minutesLeft;
            }else{
          return this.minutesLeft = 0;
            }
      
    }), catchError(this.handleError));

  }

   /*function to convert 24hour time to 12hour format*/
  convertTimeTo12HrFormat(time){
    var hour = time.substring(11,13);
    var formatValue = hour >=12 ? ' PM' : ' AM';
    hour = hour % 12;
    hour = hour === 0 ? 12: hour;
    return time.substring(0,11) + (hour < 10 ? '0' : '') + hour + time.substring(13,19) + formatValue + ' ET';
  }

  efotaDisconnectAccount(fanNo: string | string[]) {
    let url = this.utilityService.getEnvConfig().efotaDisconnectAccount + fanNo;
    return this.httpClientService.authorizedPost(url,'')
      .pipe(
        map((res: HttpResponse<any>) => res.body)
        , catchError(this.handleError));
  }

  getkmedata(querystring) {
    let url = this.utilityService.getEnvConfig().getcarekmedetails;
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
      map((res: HttpResponse<any>) => {
      return res.body;
      }), catchError(this.handleError));
    }
  
    getZteData(querystring) {
      let url = this.utilityService.getEnvConfig().getcareztedetails;
      return this.httpClientService
        .authorizedPost(url, querystring)
        .pipe(
        map((res: HttpResponse<any>) => {
        return res.body;
        }), catchError(this.handleError));
      }

  getFedata(querystring) {
    console.log(querystring)
    // let url = this.utilityService.getEnvConfig().getcarekmedetails;
    let url = this.utilityService.getEnvConfig().getcareFeDetails;
    console.log(url)
    return this.httpClientService
      .authorizedPost(url, querystring)
      .pipe(
      map((res: HttpResponse<any>) => {
      return res.body;
      }), catchError(this.handleError));
    }

    sendToAppleData(data) {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      let url = this.utilityService.getEnvConfig().sendToAppleFeRequest;
      console.log(url, data);
      return this.httpClientService
      .authorizedPost(url, data, headers)
      .pipe(
      map((res: HttpResponse<any>) => {
      return res.body;
      }), catchError(this.handleError));
    }

  validateUserEmail(data) {
    let headers = new HttpHeaders();
    // headers = headers.append('Authorization', 'Basic ' + PERMISSION[0]['basicAuth']);
    headers = headers.append('customerEmail', data.customerEmail);
    headers = headers.append('fan', data.fan);
    let url = this.utilityService.getEnvConfig().validateUserEmail;
    let fallbackUrl = ""
    if(location.href.includes("admin")){
      fallbackUrl = this.utilityService.getEnvConfig().profilePermAdmin;
    } else {
      fallbackUrl = this.utilityService.getEnvConfig().profilePerm;
    }
    console.log(url);
    return this.httpClientService.get(url, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        }),
        catchError((error) => {
          if (error.status >= 500) {
            console.log('validateUserEmail 5xx error, falling back to profileAndPermsInfo');
            return this.httpClientService.get(fallbackUrl, headers)
              .pipe(
                map((res: HttpResponse<any>) => {
                  return res.body;
                }),
                catchError(this.handleError)
              );
          }
          return this.handleError(error);
        })
      );
    }

  copyToClipboard(data: string){
  //  const jsonString = JSON.stringify(data);
    navigator.clipboard.writeText(data).then(() => {
      console.log('Row data copied to clipboard:', data);
    }).catch(err => {
      console.error('Failed to copy row data: ', err);
    });
  }
}
